import {
  filterAdoverlayData,
  formatAdoverlayData,
} from '@app/modules/logger/screens/stream/components/audit/adoverlay/utils';
import { useTimezone } from '@app/core/hooks/useTimezone';
import { getAuditListingDefaultDateRange } from '@app/modules/audit/modules/station-audit/helpers/default-listing-date-range';
import {
  PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsSortByEnum,
  PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsSortOrderEnum,
  PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsWithResultsEnum,
  pntSegmentsControllerGetSegmentAdOverlayByDate,
} from '@mi-front/api-v2';
import { Station } from '@app/core/types/stations';
import { useState } from 'react';
import { MRT_SortingState } from 'material-react-table';
import { ReportView } from '../../../../../../../../core/reports/components/ReportView';
import SortContext from '../../context';
import { AdOverlayForm } from './AdOverlayForm';
import { AdOverlayList } from './AdOverlayList';
import { AdOverlayListing } from './types';

type Props = {
  station: Station;
};

/**
 * Station ad-overlay detections listing via api-v2 PNT endpoint.
 */
export function AdOverlayView(p: Props) {
  const tz = useTimezone();
  const [sort, setSort] = useState<MRT_SortingState>([]);

  return (
    <SortContext.Provider value={{ sort, setSort }}>
      <ReportView<AdOverlayListing>
        runOnLoad
        defaultValues={{
          ...getAuditListingDefaultDateRange(tz),
        }}
        sort={sort && sort.length > 0 ? { id: sort[0].id, desc: sort[0].desc } : undefined}
        download={false}
        reportFn={async (values) => {
          const sortId = sort?.[0]?.id;
          const sortBy =
            sortId === 'brand' || sortId === 'duration' || sortId === 'date'
              ? sortId
              : PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsSortByEnum.date;

          const res = await pntSegmentsControllerGetSegmentAdOverlayByDate(p.station.slug, {
            from: values.from,
            to: values.to,
            withResults:
              PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsWithResultsEnum.true,
            sortBy,
            sortOrder: sort?.[0]?.desc
              ? PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsSortOrderEnum.desc
              : PntSegmentsControllerGetSegmentAdOverlayByDateQueryParamsSortOrderEnum.asc,
          });

          const adoverlays = formatAdoverlayData(filterAdoverlayData(res as never));
          if (adoverlays.length === 0) {
            return {
              results: [],
              total: 0,
            };
          }

          return {
            results: adoverlays,
            total: adoverlays.length,
          };
        }}
        Form={AdOverlayForm}
        Result={AdOverlayList}
      />
    </SortContext.Provider>
  );
}
